// in src/posts.js
import React from "react";
import {
    List,
    Edit,
    Create,
    Datagrid,
    ReferenceField,
    TextField,
    EditButton,
    DeleteButton,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
    Resource,
    NumberInput,
} from "react-admin";
import { LVEditToolbar, LVCreateToolbar } from "../core/toolbars";

export const AlertRuleList = (props) => (
    <List perPage={200} {...props}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="userId" />
            <Resource name="users">
                <ReferenceField reference="users" source="userId">
                    <TextField source="username"></TextField>
                </ReferenceField>
            </Resource>

            <TextField source="recordId" label="Site ID" />
            <Resource name="sites">
                <ReferenceField reference="sites" source="recordId" label="Site">
                    <TextField source="site_group_name"></TextField>
                </ReferenceField>
            </Resource>

            <TextField source="tableName" />
            <TextField source="aliasName" />
            <TextField source="alertRuleOperator" />
            <TextField source="aliasValue" />
            <EditButton />
            <DeleteButton mutationMode="pessimistic"/>
        </Datagrid>
    </List>
);

export const AlertRuleEdit = (props) => (
    <Edit {...props}>
        <SimpleForm toolbar={<LVEditToolbar />}>
            <ReferenceInput
                perPage={0}
                label="User"
                source="userId"
                reference="portal/users"
                sort={{ field: "username", order: "ASC" }}
            >
                <SelectInput optionText={(u) => u.username + ` (${u.firstname} ${u.lastname} - ${u.id})`} />
            </ReferenceInput>

            <SelectInput
                label="Target Type"
                source="tableName"
                choices={[
                    { id: "site_group_display", name: "Site" },
                    { id: "conductor_display", name: "Conductor" },
                ]}
            />

            <SelectInput
                label="Alias Field"
                source="aliasName"
                choices={[
                    {
                        id: "rating",
                        name: "Rating (Amps)",
                    },
                    {
                        id: "emf_Amps",
                        name: "Loading (Amps)",
                    },
                    {
                        id: "sag_distance",
                        name: "Conductor Sag (Meters)",
                    },
                    {
                        id: "blowout_distance",
                        name: "Conductor Blowout (Meters)",
                    },
                    {
                        id: "conductor_temp",
                        name: "Conductor Temp (Degrees)",
                    },
                ]}
            />

            <SelectInput
                label="Threshold Operator"
                source="alertRuleOperator"
                choices={[
                    { id: "above", name: "Above" },
                    { id: "below", name: "Below" },
                ]}
            />

            <TextInput source="aliasValue" />

            <ReferenceInput
                perPage={0}
                label="Site"
                source="recordId"
                reference="portal/sites"
                sort={{ field: "site_group_id", order: "ASC" }}
                filter={{ status: "active" }}
                style={{ width: "400px" }}
            >
                <SelectInput optionText={(s) => s.id + ": " + s.site_group_name + ` (${s.status})`} />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);

export const AlertRuleCreate = (props) => (
    <Create {...props}>
        <SimpleForm toolbar={<LVCreateToolbar />}>
            <ReferenceInput
                perPage={0}
                label="User"
                source="userId"
                reference="portal/users"
                sort={{ field: "username", order: "ASC" }}
            >
                <SelectInput optionText={(u) => u.username + ` (${u.firstname} ${u.lastname} - ${u.id})`} />
            </ReferenceInput>

            <SelectInput
                label="Target Type"
                source="tableName"
                choices={[
                    { id: "site_group_display", name: "Site" },
                    { id: "conductor_display", name: "Conductor" },
                ]}
            />

            <SelectInput
                label="Alias Field"
                source="aliasName"
                choices={[
                    {
                        id: "rating",
                        name: "Rating (Amps)",
                    },
                    {
                        id: "emf_Amps",
                        name: "Loading (Amps)",
                    },
                    {
                        id: "sag_distance",
                        name: "Conductor Sag (Meters)",
                    },
                    {
                        id: "blowout_distance",
                        name: "Conductor Blowout (Meters)",
                    },
                    {
                        id: "conductor_temp",
                        name: "Conductor Temp (Degrees)",
                    },
                ]}
            />

            <SelectInput
                label="Threshold Operator"
                source="alertRuleOperator"
                choices={[
                    { id: "above", name: "Above" },
                    { id: "below", name: "Below" },
                ]}
            />

            <NumberInput source="aliasValue" />

            <ReferenceInput
                perPage={0}
                label="Site"
                source="recordId"
                reference="portal/sites"
                sort={{ field: "site_group_id", order: "ASC" }}
                filter={{ status: "active" }}
                style={{ width: "400px" }}
            >
                <SelectInput optionText={(s) => s.id + ": " + s.site_group_name + ` (${s.status})`} />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);
